import React from 'react';

import { Button } from 'uiToolkitV1/Button';

interface Props {
  onCloseSecondaryPanel: () => void;
  onGoalSelect: () => void;
}

const GoalSelectionFooter = ({ onCloseSecondaryPanel, onGoalSelect }: Props) => (
  <>
    <Button variant="tertiary" mr="auto" onClick={onCloseSecondaryPanel}>
      Cancel
    </Button>
    <Button onClick={onGoalSelect}>Save</Button>
  </>
);

export default GoalSelectionFooter;
